"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgDevicesFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { d: 'M4.014 18.008H9l-1 1.996H7c-.667 0-1 .332-1 .998 0 .665.333.998 1 .998h6.763A2.989 2.989 0 0113 20v-5.984H2v1.995c0 1.332.671 1.997 2.014 1.997zM13 12.019H2V4.034c0-1.322.667-1.987 2-1.996l.457-.005a860.02 860.02 0 0115.583.003c1.307.01 1.96.676 1.96 1.998v5.73A2.989 2.989 0 0020 9h-4a3 3 0 00-3 3v.019z' }),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M16 11a1 1 0 00-1 1v8a1 1 0 001 1h4a1 1 0 001-1v-8a1 1 0 00-1-1h-4zm1.5 8a.5.5 0 100 1h1a.5.5 0 000-1h-1z' }))); };
exports.default = SvgDevicesFilled;
//# sourceMappingURL=DevicesFilled.js.map